"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SectionNotice {
    onCreate() {
        this.state = { dismissed: false };
    }
    onInput(input) {
        this.state = { dismissed: input.dismissed || false };
    }
    onDismiss() {
        this.state.dismissed = true;
        this.emit("dismiss");
    }
}
module.exports = SectionNotice;
